import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface SlowQueryRow {
  query_preview: string;
  calls: number;
  mean_ms: number;
  max_ms: number;
  min_ms: number;
  total_ms: number;
  rows: number;
  cache_hit_pct: number | null;
}

export function useSlowQueries(enabled: boolean) {
  return useQuery({
    queryKey: ["admin", "slow-queries"],
    queryFn: async (): Promise<SlowQueryRow[]> => {
      const { data, error } = await supabase.rpc("get_slow_queries");
      if (error) throw error;
      return (data ?? []) as SlowQueryRow[];
    },
    enabled,
    refetchInterval: 30_000,
    staleTime: 25_000,
  });
}

export function useResetSlowQueriesStats() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase.rpc("reset_slow_queries_stats");
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      toast.success("Estadísticas de pg_stat_statements reseteadas.");
      qc.invalidateQueries({ queryKey: ["admin", "slow-queries"] });
    },
    onError: (err: Error) => {
      toast.error(`No se pudo resetear: ${err.message}`);
    },
  });
}
